import { CQRS } from "@leancode/cqrs-client/CQRS";
import cfg from "config";
import RegistrationsClient from "Contracts/RegistrationsClient";
import loginManager from "./LoginManager";

const cqrsClient = new CQRS(cfg.registrationsEndpoint, loginManager);
const registrationsApi = RegistrationsClient(cqrsClient);
export default registrationsApi;
